module.exports = __webpack_public_path__ + "static/img/project_preper.3ca92364.png";